export { default } from './json-id-script';
